import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import "./App.css";
import Header from "./components/header/Header";
import Footer from "./components/sections/Footer";
import { Dashboard } from "./pages/Dashboard";
import SecurityPage from "./pages/SecurityPage";
import CorporateManagement from "./pages/solutions/CorporateManagementPage";
import LicenseManagementPage from "./pages/solutions/LicenseManagementPage";
import ComplianceAssurance from "./pages/solutions/ComplianceAssurance";
import ConsultantAndAdvisors from "./pages/solutions/ConsultantAndAdvisors";
import AboutUs from "./pages/aboutUs";
import ContactForm from "./pages/contactUs";
import BlogPage from "./pages/blog";
import Articles from "./pages/blog/Articles";
import Careers from "./pages/careers";
import VacancyDetails from "./pages/vacancyDetails";
import JobApplicationForm from "./pages/jobapplication";
import TermsAndCondition from "./pages/TermsAndCondition";
import PrivacyPolicy from "./pages/privacyPolicy";
import VacancyApplicationForm from "./pages/vacancyApplication";
import MeetUs from "./components/sections/MeetUs";
import BookDemo from "./pages/bookDemo";
import ArticleSecond from "./pages/blog/ArticlesSecond";
import { useEffect } from "react";
import ArticleThird from "./pages/blog/ArticlesThird";
import ArticlesFourth from "./pages/blog/ArticlesFourth";
import ArticlesFifth from "./pages/blog/ArticlesFifth";
import ArticlesSixth from "./pages/blog/ArticlesSixth";
import ArticlesEighth from "./pages/blog/ArticlesEighth";
import ArticlesSeventh from "./pages/blog/ArticlesSeventh";
import { ApplicationInsights } from "@microsoft/applicationinsights-web";
import ReactGA from "react-ga4";

ReactGA.initialize(process.env.REACT_APP_GA_ID);


function App() {


  useEffect(() => {
    const instrumentationKey = process.env.REACT_APP_INSTRUMENTATION_KEY;
    const ingestionEndpoint = process.env.REACT_APP_INGESTION_ENDPOINT;
    const liveEndpoint = process.env.REACT_APP_LIVE_ENDPOINT;
    const applicationId = process.env.REACT_APP_APPLICATION_ID;

    const appInsights = new ApplicationInsights({
      config: {
        connectionString: `InstrumentationKey=${instrumentationKey};IngestionEndpoint=${ingestionEndpoint};LiveEndpoint=${liveEndpoint};ApplicationId=${applicationId}`,
      },
    });
    appInsights.loadAppInsights();
    appInsights.trackPageView();
  }, []);

  return (
    <>
      <BrowserRouter>
      <MeetUs/>
      <Header />
        <Routes>
          <Route path="*" element={<Navigate to="/" replace />} />  
          <Route path="/" element={<Dashboard />} />
          <Route path="/security" element={<SecurityPage />} />
          <Route path="/solutions/corporate-management" element={<CorporateManagement />} />
          <Route path="/solutions/license-management" element={<LicenseManagementPage />} />
          <Route path="/solutions/compliance-assurance" element={<ComplianceAssurance />} />
          <Route path="/solutions/consultant-advisors" element={<ConsultantAndAdvisors />} />

          <Route path="/about-us" element={<AboutUs />} />
          
          <Route path="/contact-us" element={<ContactForm />} />

          <Route path="/blog" element={<BlogPage />} />
          <Route path="/blog/8" element={<ArticlesEighth />} />
          <Route path="/blog/7" element={<ArticlesSeventh />} />
          <Route path="/blog/6" element={<ArticlesSixth />} />
          <Route path="/blog/5" element={<ArticlesFifth />} />
          <Route path="/blog/4" element={<ArticlesFourth />} />
          <Route path="/blog/3" element={<Articles />} />
          <Route path="/blog/2" element={<ArticleSecond />} />
          <Route path="/blog/1" element={<ArticleThird />} />

          <Route path="/careers" element={<Careers />} />

          <Route path="/careers/vacancy-details/:id" element={<VacancyDetails />} />
          <Route path="/careers/application" element={<JobApplicationForm />} />


          <Route path="/terms-and-condition" element={<TermsAndCondition />} />
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          <Route path="/careers/vacancy-application" element={<VacancyApplicationForm />} />

          <Route path="/book-demo" element={<BookDemo />} />
        </Routes>
      <Footer />
      </BrowserRouter>
    </>
  );
}

export default App;
